import { FlowParameterType } from '../../enums/flow-parameters/flow-parameter-type';
import { Guid } from '../guid';

export class FlowParameter {
	id = Guid();
	key = '';
	type: FlowParameterType = FlowParameterType.Variable;
	isList?: boolean;
	defaultValue = '';
	required = false;
	flowID = '';
	taskID = '';
	taskName = '';
	integrationStep = '';

	constructor(init?: Partial<FlowParameter>) {
		Object.assign(this, init);
	}
}
